import { defineMessages } from 'react-intl';

const linkMessages = defineMessages({
  github: {
    id: 'links.github',
    defaultMessage: 'GitHub',
  },
  linkedin: {
    id: 'links.linkedin',
    defaultMessage: 'LinkedIn',
  },
  resume: {
    id: 'links.resume',
    defaultMessage: 'Resume',
  },
});

export default linkMessages;
